module.exports = __webpack_public_path__ + "img/favicon.721bb579.png";